import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import { getEntityFromMap } from '@/utils/entityUtils';

import { Price } from '../../models/interfaces/Price';
import { Subscription } from '../../models/interfaces/Subscriptions';
import { getPriceKey, getSubscriptionKey } from '../../utils/subscriptions';
import { authenticationRequired } from '../actions/authentication/authenticationRequired';
import { logout } from '../actions/authentication/logout';
import { subscriptionCanceled } from '../actions/subscription/cancelSubscription';
import { subscriptionPricingChanged } from '../actions/subscription/changeSubscriptionPricing';
import { pricesFetched } from '../actions/subscription/fetchPrices';
import { subscriptionsFetched } from '../actions/subscription/fetchSubscriptions';

export interface SubscriptionReducerState {
  readonly prices: Map<string, Price[]>;
  readonly subscriptions: Map<string, Subscription[]>;
}

const defaultState: SubscriptionReducerState = {
  prices: Map<string, Price[]>(),
  subscriptions: Map<string, Subscription[]>(),
};

const subscriptionReducer = createReducer<SubscriptionReducerState>({}, defaultState);

subscriptionReducer.on(pricesFetched, (state, { prices, placeUuid, feature }) => ({
  ...state,
  prices: state.prices.set(getPriceKey(placeUuid, feature), prices),
}));

subscriptionReducer.on(subscriptionsFetched, (state, { subscriptions, feature, placeUuid }) => ({
  ...state,
  subscriptions: state.subscriptions.set(getSubscriptionKey(placeUuid, feature), subscriptions),
}));

subscriptionReducer.on(subscriptionCanceled, (state, { subscription, placeUuid, feature }) => {
  const subscriptions = getEntityFromMap(state.subscriptions, getSubscriptionKey(placeUuid, feature));
  const updated = subscriptions.map((currentSubscription) => (currentSubscription.id === subscription.id ? subscription : currentSubscription));
  return {
    ...state,
    subscriptions: state.subscriptions.set(getSubscriptionKey(placeUuid, feature), updated),
  };
});

subscriptionReducer.on(subscriptionPricingChanged, (state, { subscription, placeUuid, feature }) => {
  const subscriptions = getEntityFromMap(state.subscriptions, getSubscriptionKey(placeUuid, feature));
  const updated = subscriptions.map((currentSubscription) => (currentSubscription.id === subscription.id ? subscription : currentSubscription));
  return {
    ...state,
    subscriptions: state.subscriptions.set(getSubscriptionKey(placeUuid, feature), updated),
  };
});

subscriptionReducer.on(logout, () => defaultState);

subscriptionReducer.on(authenticationRequired, () => defaultState);

export default subscriptionReducer;
